import React from 'react'
import Head from 'next/head'
import FeatSoftwares from 'components/software/FeatSoftwares'
import { Get_Software_ListDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = `Trading Software, Apps & Tools`
const description = `A list of popular stock trading software,applications, tools and products. 
             Know features, key highlights, advantages, disadvantages, FAQs on investing apps.`

export default function Softwares(props) {
  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_softwares: { data: allSoftwares },
    all_pages: { data: allPages },
  } = pageData

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <FeatSoftwares key="FeatSoftware" allSoftwares={allSoftwares} />
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: Get_Software_ListDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}
